export interface UserAutomation {
  uuid: string;
  templateId: string;
  isActive: boolean;
  dayOfMonth: number;
  notificationEmail: string;
  email: string;
  sendToEmployeePortal: boolean;
  sendToManagerPortal: boolean;
  // New execution time fields
  executionHour: number;
  executionMinute: number;
  retryHour: number;
  retryMinute: number;
  // DSN specific fields
  generateBulletinOption?: 'generate-only' | 'generate-and-send';
  dsnOption?: 'calculate-only' | 'calculate-and-send';
  /** Demande de variables : ce que le lien ouvre (décision Rose du 21/09/2026). */
  collecteCanal?: 'reponse' | 'saisie' | 'les_deux' | null;
  sendDsnByEmail?: boolean;
  dsnEmail?: string;
  customDescription?: string;
  // Edition specific fields (metadata)
  editionOptionValue?: string;
  editionOptionName?: string;
  editionStartMonth?: number;
  editionStartYear?: number;
  editionEndMonth?: number;
  editionEndYear?: number;
  editionEmail?: string;
  createdAt: string;
  updatedAt: string;
  folder: {
    uuid: string;
    name: string;
    path: string;
  };
  domain: {
    uuid: string;
    name: string;
    url: string;
    status: string;
  };
}

export interface UserAutomationsResponse {
  data: UserAutomation[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface UserAutomationsParams {
  page?: number;
  limit?: number;
  domainUuid?: string;
  status?: 'active' | 'inactive';
  search?: string;
  templateId?: string;
  organisationUuid?: string;
}

export type AutomationStatus = 'active' | 'inactive' | 'all';

export const AUTOMATION_TEMPLATES = {
  'generate-bulletin': {
    nameKey: 'automation.templates.generateBulletin.name',
    descriptionKey: 'automation.templates.generateBulletin.description',
    name: 'Generate Bulletin',
    description: 'Generate payroll bulletins automatically',
  },
  'calculate-dsn': {
    nameKey: 'automation.templates.calculateDsn.name',
    descriptionKey: 'automation.templates.calculateDsn.description',
    name: 'Calculate DSN',
    description: 'Calculate DSN declarations automatically',
  },
  'generate-edition': {
    nameKey: 'automation.templates.generateEdition.name',
    descriptionKey: 'automation.templates.generateEdition.description',
    name: 'Generate Edition',
    description: 'Generate OpenPaye editions on schedule',
  },
  'demande-variables': {
    nameKey: 'automation.templates.demande-variables.name',
    descriptionKey: 'automation.templates.demande-variables.description',
    name: 'Demande de variables',
    description: 'Envoie au client le lien de saisie de ses éléments de paie',
  },
} as const;
